// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".expand-btn .v-icon{transform:rotate(0);transition:transform .2s}.expand-btn.is-expanded .v-icon{transform:rotate(-180deg)}", ""]);
// Exports
module.exports = exports;
